let overlayInstanceCount = 0;

/**
 * Build a process-unique, render-stable id used as the `source` of overlay
 * coordination events (see `FILTER_OVERLAY_OPEN_EVENT`). Store the result in a
 * ref so an instance keeps the same id across renders.
 *
 * @param  {string} prefix label identifying the overlay kind
 * @return {string}        unique overlay instance id
 */
export const nextOverlayInstanceId = (prefix = 'overlay') => {
    overlayInstanceCount += 1;
    return `${prefix}-${overlayInstanceCount}`;
};

/**
 * Whether the given target exposes DOM event APIs.
 *
 * @param  {Object}  target candidate event target
 * @return {boolean}        true when listeners can be attached
 */
export const supportsOverlayEvents = target =>
    !!target &&
    typeof target.addEventListener === 'function' &&
    typeof target.removeEventListener === 'function' &&
    typeof target.dispatchEvent === 'function';

export default nextOverlayInstanceId;
